var _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgHealthInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 53.5C112 82.4949 88.4949 106 59.5 106C30.5051 106 7 82.4949 7 53.5C7 24.5051 30.5051 1 59.5 1C88.4949 1 112 24.5051 112 53.5Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13075_22222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 105,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53.5C112 82.4949 88.4949 106 59.5 106C30.5051 106 7 82.4949 7 53.5C7 24.5051 30.5051 1 59.5 1C88.4949 1 112 24.5051 112 53.5Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13075_22222)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 17,
    width: 53.2174,
    height: 68,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 27C66 30.3137 63.3137 33 60 33C56.6863 33 54 30.3137 54 27C54 23.6863 56.6863 21 60 21C63.3137 21 66 23.6863 66 27Z",
    fill: "#E23E5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 23.5C59.4477 23.5 59 23.9477 59 24.5V26H57.5C56.9477 26 56.5 26.4477 56.5 27C56.5 27.5523 56.9477 28 57.5 28H59V29.5C59 30.0523 59.4477 30.5 60 30.5C60.5523 30.5 61 30.0523 61 29.5V28H62.5C63.0523 28 63.5 27.5523 63.5 27C63.5 26.4477 63.0523 26 62.5 26H61V24.5C61 23.9477 60.5523 23.5 60 23.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13075_22222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.949 89.288C66.132 87.685 65.3514 85.0731 63.2055 83.4542C61.0597 81.8352 58.3611 81.8223 57.1781 83.4254C55.9951 85.0284 56.7757 87.6403 58.9216 89.2592C61.0674 90.8782 63.766 90.8911 64.949 89.288Z",
    fill: "#1E5D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.964 80.0944C69.4513 78.7739 69.2168 76.0632 67.4404 74.0398C65.6639 72.0165 63.0182 71.4466 61.5309 72.7671C60.0436 74.0875 60.278 76.7982 62.0544 78.8216C63.8309 80.845 66.4767 81.4148 67.964 80.0944Z",
    fill: "#1E5D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7719 69.8711C76.9755 67.2998 74.7863 65.6822 72.8821 66.2581C70.9779 66.8339 70.0799 69.3852 70.8763 71.9564C71.6727 74.5277 73.862 76.1452 75.7662 75.5694C77.6703 74.9935 78.5683 72.4423 77.7719 69.8711Z",
    fill: "#1E5D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.451 71.976C88.1352 69.3072 86.2729 67.3158 84.2915 67.5282C82.3101 67.7406 80.9599 70.0763 81.2758 72.7452C81.5916 75.414 83.4539 77.4053 85.4353 77.1929C87.4167 76.9805 88.7668 74.6448 88.451 71.976Z",
    fill: "#1E5D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.612 82.5842C88.5179 85.8252 86.1662 90.7444 81.3627 93.5691C76.5592 96.3938 71.1172 96.0578 69.2113 92.8167C67.3054 89.5757 68.6344 82.9236 73.4406 80.0973C78.2467 77.271 84.7061 79.3431 86.612 82.5842Z",
    fill: "#1E5D8F"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.3916,
    y: 37.1304,
    width: 38.4348,
    height: 2.21739,
    rx: 1,
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.3916,
    y: 46.7391,
    width: 38.4348,
    height: 2.21739,
    rx: 1,
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.3916,
    y: 51.913,
    width: 38.4348,
    height: 2.21739,
    rx: 1,
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.3916,
    y: 57,
    width: 38.4348,
    height: 2.21739,
    rx: 1,
    fill: "#4B81AC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 6.27543C0.625 5.93148 0.916786 5.64485 1.2892 5.6341C1.40437 5.63051 12.4884 5.25789 18.9845 0.163032C19.2532 -0.0519407 19.6487 -0.0555235 19.9174 0.15945L19.9213 0.163032C26.4173 5.26148 37.4745 5.6341 37.5858 5.63768C37.9544 5.64843 38.25 5.93148 38.25 6.27902V6.32918C38.25 15.1861 36.6989 27.5685 29.0511 36.2427C24.4209 41.4952 19.8329 42.8782 19.6371 42.9355L19.4298 43L19.2148 42.9355C19.019 42.8782 14.4579 41.4952 9.82777 36.2427C2.17607 27.5649 0.625 15.1861 0.625 6.32559V6.27543Z",
    fill: "#3A8761"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1985 21.0833L17.3649 25.0842C17.7522 25.4561 18.364 25.4557 18.7509 25.0834L27.8022 16.373C28.4562 15.7436 28.4562 14.6969 27.8022 14.0675C27.1828 13.4714 26.203 13.4714 25.5836 14.0675L18.055 21.3126L15.4146 18.776C14.7945 18.1803 13.8144 18.1814 13.1956 18.7786C12.5428 19.4086 12.5441 20.4549 13.1985 21.0833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13075_22222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.2408,
    height: 28.0324,
    fill: "white",
    transform: "translate(51.9404 78.3468) rotate(-30.4579)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHealthInsurance);
export default __webpack_public_path__ + "static/media/imgHealthInsurance.2567169405d6bae081726f372936077d.svg";
export { ForwardRef as ReactComponent };